import { PipeTransform, Injectable, Pipe }     from '@angular/core';
@Pipe({
    name: 'replace',
    standalone: false
})
@Injectable()
export class ReplacePipe implements PipeTransform {
  constructor(){}
  transform(item: any, replace:any, replacement:any): any {
    if(item == null) return "";
    item = item.replace(replace, replacement);
    return item;
  }
}